module.exports = __webpack_public_path__ + "static/media/Operandum-Platform__Original_small.b1f4a6a5.png";